import { render, staticRenderFns } from "./DevelopmentDegreeMDN.vue?vue&type=template&id=666741a3"
import script from "./DevelopmentDegreeMDN.vue?vue&type=script&lang=js"
export * from "./DevelopmentDegreeMDN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports